import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  snappIcon,
  dorsaIcon,
  modisehIcon,
  tapsiIcon,
  novinCharmIcon,
} from 'assets/icons';
import raychat_logo from 'assets/icons/raychat-logo.svg';
import './styles.scss';

const logos_fa = [
  { icon: snappIcon, alt: 'Snapp' },
  { icon: dorsaIcon, alt: 'Dorsa' },
  { icon: modisehIcon, alt: 'Modiseh' },
  { icon: tapsiIcon, alt: 'Tapsi' },
  { icon: novinCharmIcon, alt: 'Novin' },
];

const logos_en = Array(5).fill({ icon: raychat_logo, alt: 'Snapp' });

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

const AuthLogos = ({ title }) => {
  const { locale } = useSelector(mapState);

  const logos = locale === 'fa' ? logos_fa : logos_en;

  return (
    <div className='login_logos'>
      <section className='container'>
        <h5>{title}</h5>
        <div className='login_logos_inner flex'>
          {logos.map(({ icon, alt }, index) => (
            <div key={index} className='flex image-wrapper'>
              <img src={icon} alt='' />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

AuthLogos.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AuthLogos;
